import React, {useState} from 'react'
import {useNavigate, useSearchParams} from "react-router-dom";
import {VscsApi} from "../../services/VscsApi";
import {useMount} from "ahooks";
import {Button, Card, Image, Modal, notification, Row, Space, Typography} from "antd";
import SimpleTips from "../../containers/SimpleTips";
import {ValueUtils} from "../../utils/ValueUtils";
import {
    CloseCircleOutlined,
    ExclamationCircleOutlined,
    QuestionCircleOutlined,
    UserSwitchOutlined
} from "@ant-design/icons";

const {Text} = Typography

let page = 0

const VscsPersonFacePage = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const personId = searchParams.get("id")

    const [hasMore, setHasMore] = useState(true)
    const [loading, setLoading] = useState(true)
    const [person, setPerson] = useState({})
    const [personFaces, setPersonFaces] = useState([])


    const requestData = (replace = false) => {
        if (replace) {
            page = 0
        }
        setLoading(true)
        VscsApi.personFaces(personId, page)
            .onSuccess(data => {
                setHasMore(data.length > 0)
                let baseData = []
                if (!replace) {
                    baseData = [...personFaces]
                }
                setPersonFaces([...baseData, ...data])
                page++
            })
            .onComplete(() => {
                setLoading(false)
            })
    }

    useMount(() => {
        VscsApi.person(personId)
            .onSuccess(setPerson)
        requestData()
    })

    const mapGender = (value) => {
        if (value === "-1") {
            return "未知"
        }
        if (value === "1") {
            return "女"
        }
        if (value === "0") {
            return "男"
        }
        return "无法识别"
    }


    const handleDeletePersonClick = () => {
        Modal.confirm({
            title: '人物移除确认',
            icon: <ExclamationCircleOutlined/>,
            content: '人物移除后将解除本页的人脸关联并重新计算。【基准脸照片将被删除】',
            okText: '确认',
            cancelText: '取消',
            onOk() {
                VscsApi.deletePerson(personId)
                    .onSuccess(() => {
                        VscsApi.person(personId)
                            .onSuccess(setPerson)
                        requestData(true)
                        setPerson({})
                        setPersonFaces([])
                        notification.open({
                            message: '人物已移除',
                            description:
                                '因人物移除而无法使用索引，请离开本页面。',
                            duration: 0,
                        })
                    })
            }
        });
    }

    const handleRemovePersonClick = () => {
        Modal.confirm({
            title: '人物重置确认',
            icon: <ExclamationCircleOutlined/>,
            content: '人物重置后将解除本页的人脸关联并重新计算。',
            okText: '确认',
            cancelText: '取消',
            onOk() {
                VscsApi.removePerson(personId)
                    .onSuccess(() => {
                        VscsApi.person(personId)
                            .onSuccess(setPerson)
                        requestData(true)
                        setPerson({})
                        setPersonFaces([])
                        notification.open({
                            message: '人物已重置',
                            description:
                                '因人物重置而无法使用索引，请离开本页面。',
                            duration: 0,
                        })
                    })
            }
        });
    }

    const handleResetFaceClick = (personFace) => {
        Modal.confirm({
            title: '不是这个人？',
            icon: <ExclamationCircleOutlined/>,
            content: '断开这张脸图与此人的关联，并让其重新匹配。【确认后，此脸图将永远无法建立与此人物的联系】',
            okText: '确认',
            cancelText: '取消',
            onOk() {
                VscsApi.resetFace(personFace.id)
                    .onSuccess(() => {
                        requestData(true)
                    })
            }
        });
    }

    const handleRemoveFaceClick = (personFace) => {
        Modal.confirm({
            title: '这张照片太模糊？',
            icon: <ExclamationCircleOutlined/>,
            content: '【确认后，这张照片将会被删除】',
            okText: '确认',
            cancelText: '取消',
            onOk() {
                VscsApi.removeFace(personFace.id)
                    .onSuccess(() => {
                        requestData(true)
                    })
            }
        });
    }

    const handleChangeCoverClick = (personFace) => {
        Modal.confirm({
            title: '重新设置基准脸',
            icon: <ExclamationCircleOutlined/>,
            content: '设置基准脸后，将重置人物关联并重新计算与基准脸相关的联系。【请尽量选择正脸照片并且足够清晰的基准脸】',
            okText: '确认',
            cancelText: '取消',
            onOk() {
                VscsApi.setPersonFaceCover(personFace.id)
                    .onSuccess(() => {
                        VscsApi.person(personId)
                            .onSuccess(setPerson)
                        requestData(true)
                    })
            }
        });
    }

    return (
        <>
            <Card title={"基础人物"}
                  extra={
                      <Space>
                          <Button type="link" danger onClick={() => navigate('/vscs/person/mix?id=' + personId)}>合并人物</Button>
                          <Button type="link" danger onClick={handleDeletePersonClick}>移除人物</Button>
                          <Button type="link" danger onClick={handleRemovePersonClick}>重新计算</Button>
                          <Button type="link" onClick={() => navigate('/vscs/person/timeline?id=' + personId)}>时间轴</Button>
                      </Space>
                  }
                  style={{marginBottom: 16}}>
                <Space direction="vertical">
                    <Image
                        height={101}
                        width={101}
                        src={person.properties?.face?.imageUrl}
                    />
                    <SimpleTips
                        tips={[
                            "#" + person.id,
                            "推测年龄：" + person.age,
                            "推测性别：" + mapGender(person.gender)
                        ]}
                    />
                </Space>
            </Card>
            <Card>
                <Space wrap>
                    {
                        personFaces.map(personFace =>
                            <Card size="small"
                                  key={personFace.id}
                                  style={{width: 200, height: 361}}
                                  cover={<Image
                                      height={200}
                                      style={{objectFit: 'cover'}}
                                      src={personFace.properties.face.imageUrl}
                                  />}
                                  actions={[
                                      <UserSwitchOutlined key="cover" onClick={() => {
                                          handleChangeCoverClick(personFace)
                                      }}/>,
                                      <QuestionCircleOutlined key="reset" onClick={() => {
                                          handleResetFaceClick(personFace)
                                      }}/>,
                                      <CloseCircleOutlined key="remove" onClick={() => {
                                          handleRemoveFaceClick(personFace)
                                      }}/>,
                                  ]}>
                                <Space direction="vertical">
                                    <Text style={{fontSize: 13, margin: 0}}>可能性：{personFace.similar}</Text>
                                    <Text ellipsis={{rows: 1}}
                                          style={{fontSize: 13, margin: 0}}>{personFace.properties?.venue?.name}</Text>
                                    <Text style={{
                                        fontSize: 13,
                                        margin: 0
                                    }}>{ValueUtils.formatDateOrEmpty(personFace.appearTime, "YYYY-MM-DD HH:mm:ss")}</Text>
                                </Space>
                            </Card>
                        )
                    }
                </Space>
                {
                    hasMore && <Row justify="center" style={{margin: 16}}>
                        <Button loading={loading} onClick={() => requestData()}>更多</Button>
                    </Row>
                }
            </Card>
        </>
    )
}

export default VscsPersonFacePage